module.exports = __webpack_public_path__ + "img/time-icon.9716315b.svg";